export type Role        = "Clerk" | "Manager";
export type IDProvider  = "google" | "local";

// This is for clerks who will login to the backend to review the applications
export interface User {
    _id                     : string;
    agencyId                : string;
    createdAt               : number;
    updatedAt               : number;
    picture                 : string;
    emailAddress            : string;
    fname                   : string;
    lname                   : string;
    lastLoginAt?            : number;
    roles                   : Role[];
    idProvider              : IDProvider;   // identity provider
    idProviderId            : string;       // user identifier within that identity provider
    password                : string;       // sha256
    passwordRecoveryTokens  : Record<string,number>;
}

export type Hydrated = Omit<User,'password'|'passwordRecoveryTokens'>;

export type Dehydrated = [
    string,                 // _id
    string,                 // agencyId
    number,                 // createdAt
    number,                 // updatedAt
    string,                 // picture
    string,                 // emailAddress
    string,                 // fname
    string,                 // lname
    number,                 // lastLoginAt
    Role[],
    IDProvider,
    string
];

export const hydrate = ( user:Dehydrated ) : Hydrated => {
    if( !Array.isArray(user) )
        throw Error(`Invalid argument`);
    return {
        _id                 : user[0],
        agencyId            : user[1],
        createdAt           : user[2],
        updatedAt           : user[3],
        picture             : user[4],
        emailAddress        : user[5],
        fname               : user[6],
        lname               : user[7],
        lastLoginAt         : user[8],
        roles               : user[9],
        idProvider          : user[10],
        idProviderId        : user[11]
    };
}

export const dehydrate = ( user:Hydrated ) : Dehydrated => {
    if( Array.isArray(user) || (typeof user !=='object') || (user===null)  )
        throw Error(`Invalid argument`);
    // Users are dehydrated before they are sent to the client
    const dehydrated = [
        user._id,
        user.agencyId,
        user.createdAt,
        user.updatedAt,
        user.picture,
        user.emailAddress,
        user.fname,
        user.lname,
        user.lastLoginAt,
        user.roles,
        user.idProvider,
        user.idProviderId
    ];
    return dehydrated as Dehydrated;
}

export const phoneRegexp   = /^[0-9]{7,}$/;
export const emailRegexp   = /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;

export default User;